import React from 'react';
import { Typography, TableRow, TableCell, Chip, Card, CardContent, CardActions, makeStyles } from "@material-ui/core";
import classNames from 'classnames';

import BillingStatement from '../../../entities/BillingStatement';
import { useIsMobile } from '../../../components/Mui3WidthProvider';

const useStyles = makeStyles((theme) => ({
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100%',
        textOverflow: 'ellipsis'
    },
    chip: {
        height: 20,
        marginLeft: 8,
        verticalAlign: "unset"
    },
    paidChip: {
        backgroundColor: "rgb(214,236,255)"
    },
    mobileDetails: {
        textDecoration: "none",
        color: "rgb(0, 0, 0, .85)",
        paddingLeft: 8,
        fontWeight: 400,
    }
}));

interface Props {
    row: BillingStatement;
}

export function BillingStatementsTable(props:Props) {
    const { row } = props;
    const isMobile = useIsMobile();
    const classes = useStyles();

    return (
        <>
            {!isMobile &&
                <TableRow key={row.id}>
                    <TableCell component="th" scope="row">
                        {row.amount}
                    <Chip className={classNames(classes.chip, row.paid && classes.paidChip)} label={row.paid ? "Paid" : "Not Paid"} />
                    </TableCell>
                    <TableCell align="right">{row.invoiceNumber}</TableCell>
                    <TableCell align="right">{new Date(row.createdDate).toLocaleDateString()}</TableCell>
                    <TableCell align="right">
                        <a href={row.paymentUrl} target="_blank" rel="noopener noreferrer">
                            View Details
                        </a>
                    </TableCell>
                </TableRow>
            }
            {isMobile &&
                <Card>
                    <CardContent>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            {new Date(row.createdDate).toLocaleDateString()}
                        </Typography>
                        <Typography variant="h5" component="h2">
                            {row.amount}
                            <Chip className={classNames(classes.chip, row.paid && classes.paidChip)} label={row.paid ? "Paid" : "Not Paid"} />
                        </Typography>
                        <Typography color="textSecondary">
                            {row.invoiceNumber}
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <a href={row.paymentUrl} className={classes.mobileDetails} target="_blank" rel="noopener noreferrer">
                            View Details
                        </a>
                    </CardActions>
                </Card>
            }
        </>
    );
}